import {ArrowLeft} from "@unibuddy/patron";

export default ArrowLeft;
